if (!customElements.get('an-gallery-dots')) {
  customElements.define('an-gallery-dots', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('media-gallery');
      if (!this.gallery) return;
      this.viewer = this.gallery.querySelector('[id^="GalleryViewer"]');
      this.onSlide = event => this.update(event.detail?.currentElement?.dataset.mediaId);
      this.viewer?.addEventListener('slideChanged', this.onSlide);
      this.observer = new MutationObserver(() => this.build());
      this.observer.observe(this.gallery, {childList:true, subtree:true, attributes:true, attributeFilter:['class','hidden']});
      this.build();
    }
    build() {
      this.slides = [...this.gallery.querySelectorAll('[id^="Slider-Gallery"] > [data-media-id]')].filter(slide => !slide.hidden);
      const signature = this.slides.map(slide => slide.dataset.mediaId).join('|');
      if (signature !== this.signature) {
        this.signature = signature;
        this.replaceChildren();
        this.slides.forEach((slide,index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', this.dataset.dotLabel.replace('__INDEX__', index + 1));
          dot.addEventListener('click', () => {this.gallery.setActiveMedia(slide.dataset.mediaId,false); this.update(slide.dataset.mediaId);});
          this.append(dot);
        });
      }
      const hidden = this.slides.length < 2;
      if (this.hidden !== hidden) this.hidden = hidden;
      this.update();
    }
    update(id) {
      const active = id || this.slides?.find(slide => slide.classList.contains('is-active'))?.dataset.mediaId;
      [...this.children].forEach((dot,index) => {
        const current = this.slides[index]?.dataset.mediaId === active;
        const value = String(current);
        if (dot.getAttribute('aria-current') !== value) dot.setAttribute('aria-current', value);
      });
    }
    disconnectedCallback() {this.observer?.disconnect();this.viewer?.removeEventListener('slideChanged',this.onSlide);}
  });
}
